define('TavanoTeam.LoyalityLandingForm.Model'
,	[	'Backbone'
    ,	'underscore'
    ,	'Utils'
]
,	function (
    Backbone
    ,	_
    ,	Utils
)
{
    'use strict';

    return Backbone.Model.extend({

        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/LoyalityLandingForm.Service.ss'))

        ,	validation: {
            firstname: {
                required: true
                ,	msg: _('First Name is required').translate()
            }
            ,	lastname: {
                required: true
                ,	msg: _('Last Name is required').translate()
            }
            ,	email: {
                required: true
                ,	pattern: 'email'
                ,	msg: _('Valid Email is required').translate()
            }          
            ,	company: {
                    required: true
                    ,	msg: _('Company is required').translate()
            }
            ,    phone:  {
                    required: true
                    ,	msg: _('Phone is required').translate()
            }
            ,    city:  {
                    required: true
                    ,	msg: _('City is required').translate()        
            }
            ,   roles:  {
                required: true
                ,	msg: _('Customer/Marketing Role is required').translate()        
            }
            ,   interest:  {
                required: true
                ,	msg: _('Interest is required').translate()        
            }
            ,   state:  {
                required: true
                ,	msg: _('State is required').translate()        
             }
        }
    });
});
